module.exports = __webpack_public_path__ + "static/thumb-70cc9db479c7f75658bf9a4747a39db9.png";